import { useRecoilValue } from 'recoil';
import { CartAtom } from '~/services/cart';
import storeConfigAtom from '~/services/store-config/store-config.atom';
import Progress, { PromotionThreshold } from './Progress';
import { isEmpty, minBy } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { getLocalStorage, LocalStorageKey } from '~/utils/local-storage';

type ProgressDiscountProps = {
    data?: PromotionThreshold[];
    currentSubtotal?: number;
};

const ProgressDiscount = ({ data = [], currentSubtotal = 0 }: ProgressDiscountProps) => {
    const cart = useRecoilValue(CartAtom.cartSelector);
    const storeConfig = useRecoilValue(storeConfigAtom.store);
    const [isReady, setIsReady] = useState(false);
    const minSubtotal = storeConfig?.step_discount_config?.length
        ? Math.min(...storeConfig?.step_discount_config?.map((threshold) => Number(threshold.subtotal)))
        : 0;
    const isSamePromotionsIndex =
        !!cart?.applied_coupons?.length && cart?.subtotal > minSubtotal && cart.prices.discounts?.length === 1;

    useEffect(() => {
        const discountLocalStorage = getLocalStorage(LocalStorageKey.DISCOUNT_CODE);
        if ((!discountLocalStorage || cart?.applied_coupons?.includes(discountLocalStorage)) && !isReady) {
            setIsReady(true);
        }
    }, [cart?.applied_coupons]);
    if (!isReady) return null;
    if (isEmpty(storeConfig?.step_discount_config)) return null;

    return (
        <Progress
            currentSubtotal={!!isSamePromotionsIndex ? 0 : cart?.subtotal}
            isSamePromotions={!!isSamePromotionsIndex}
            promotionThresholds={storeConfig?.step_discount_config as unknown as PromotionThreshold[]}
        />
    );
};

export default ProgressDiscount;
